import OofState from 'owa-service/lib/contract/OofState';
import {
    getIsAutomaticReplyEnabled,
    getPeriodicReplyEnabled,
} from '../selectors/getStoreProperties';

/**
 * Utility function to get auto reply status
 * @returns OofState type
 */
export default function getAutoReplyStatus() {
    let isAutomaticReplyEnabled = getIsAutomaticReplyEnabled();
    let periodicReplyEnabled = getPeriodicReplyEnabled();
    let autoReplyState: OofState;
    if (isAutomaticReplyEnabled) {
        autoReplyState = OofState.Enabled;
        if (periodicReplyEnabled === true) {
            autoReplyState = OofState.Scheduled;
        }
    } else {
        autoReplyState = OofState.Disabled;
    }

    return autoReplyState;
}
